import React from "react";

import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import ImageGallery from "react-image-gallery";
import { ClickActionEvent } from "../../util/analytics";

import Books from "./Data";

const sxHeroContent = { py: 8 };
const sxCardGrid = { pt: 8, pb: 8 };

export default function BooksIRead() {
  return (
    <React.Fragment>
      <div style={{ backgroundColor: "#0c2d48" }}>
        <Box sx={{ ...sxHeroContent, backgroundColor: "#0c2d48" }}>
          <Container maxWidth="md">
            <Typography
              component="h1"
              variant="h3"
              align="center"
              style={{ color: "#c1eeec" }}
              gutterBottom
            >
              Books I Read 📚
            </Typography>
            <Typography
              variant="h6"
              align="center"
              style={{ color: "#c1eeec" }}
              paragraph
            >
              These are some of the books I have read which helped me a lot to
              become a better version of me. Some of them are recommended by my
              colleagues and some are by people I follow as my mentor.
            </Typography>
          </Container>
        </Box>
        <Container sx={sxCardGrid} maxWidth="md">
          <ImageGallery
            items={Books}
            onSlide={(currentIndex) => {
              ClickActionEvent(
                "Books " + Books[currentIndex]?.originalTitle,
                "books section",
                "book slide changed"
              );
            }}
            showIndex={false}
            showBullets={true}
            autoPlay={false}
            slideInterval={3000}
            slideDuration={450}
            showFullscreenButton={true}
            lazyLoad={true}
            showNav={true}
            showThumbnails={false}
          />
        </Container>
      </div>
    </React.Fragment>
  );
}
